import { createAction } from '@/utils/actionCreator';

import ActionTypes from './actionTypes';

export const inviteUser = createAction(ActionTypes.INVITE_POST, 'email');
